import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import Tabs from "../../common/tabs";
import EnforcementReportsViewModel from "viewModels/enforcement/reporting/enforcementReportsViewModel";

const EnforcementReportsView: ViewComponent<EnforcementReportsViewModel> = observer(({ vm }) => (
  <>
    <h3 className="mb-4">{vm.name}</h3>
    <Tabs vm={vm} />
  </>
));

registerView(EnforcementReportsView, EnforcementReportsViewModel);
